import { useState } from "react";

export const CIRCLE_SUGGESTED_EMOJIS = [
  '⭐', '✨', '🌈', '🌊', '🔥', '🧩', '🐢', '🐍', '🦋', '🌱', '💫', '🪐',
  '🌙', '☀️', '🌸', '🌻', '🌿', '🍀', '🎵', '🎨', '🏔️', '💎', '⚡', '🌺',
  '🦄', '🐉', '🌊', '🍃', '🎯', '🧸', '🪷', '🌠',
];

const BLOCKLIST_CATEGORIES = [
  'Smileys & Emotion',
  'People & Body',
  'Travel & Places',
];

const BLOCKED_PATTERN = /[\u{1F1E0}-\u{1F1FF}]/u;

const BROADER_EMOJIS_RAW: Array<{ emoji: string; category: string }> = [
  { emoji: '🐶', category: 'Animals & Nature' },
  { emoji: '🐱', category: 'Animals & Nature' },
  { emoji: '🐭', category: 'Animals & Nature' },
  { emoji: '🐹', category: 'Animals & Nature' },
  { emoji: '🐰', category: 'Animals & Nature' },
  { emoji: '🦊', category: 'Animals & Nature' },
  { emoji: '🐻', category: 'Animals & Nature' },
  { emoji: '🐼', category: 'Animals & Nature' },
  { emoji: '🐨', category: 'Animals & Nature' },
  { emoji: '🐯', category: 'Animals & Nature' },
  { emoji: '🦁', category: 'Animals & Nature' },
  { emoji: '🐮', category: 'Animals & Nature' },
  { emoji: '🐷', category: 'Animals & Nature' },
  { emoji: '🐸', category: 'Animals & Nature' },
  { emoji: '🐒', category: 'Animals & Nature' },
  { emoji: '🐔', category: 'Animals & Nature' },
  { emoji: '🦋', category: 'Animals & Nature' },
  { emoji: '🐢', category: 'Animals & Nature' },
  { emoji: '🐍', category: 'Animals & Nature' },
  { emoji: '🐳', category: 'Animals & Nature' },
  { emoji: '🦈', category: 'Animals & Nature' },
  { emoji: '🐬', category: 'Animals & Nature' },
  { emoji: '🦅', category: 'Animals & Nature' },
  { emoji: '🦚', category: 'Animals & Nature' },
  { emoji: '🦜', category: 'Animals & Nature' },
  { emoji: '🦋', category: 'Animals & Nature' },
  { emoji: '🐝', category: 'Animals & Nature' },
  { emoji: '🐛', category: 'Animals & Nature' },
  { emoji: '🐞', category: 'Animals & Nature' },
  { emoji: '🦄', category: 'Animals & Nature' },
  { emoji: '🐉', category: 'Animals & Nature' },
  { emoji: '🌿', category: 'Animals & Nature' },
  { emoji: '🍀', category: 'Animals & Nature' },
  { emoji: '🌱', category: 'Animals & Nature' },
  { emoji: '🌸', category: 'Animals & Nature' },
  { emoji: '🌺', category: 'Animals & Nature' },
  { emoji: '🌻', category: 'Animals & Nature' },
  { emoji: '🌹', category: 'Animals & Nature' },
  { emoji: '🌷', category: 'Animals & Nature' },
  { emoji: '🪷', category: 'Animals & Nature' },
  { emoji: '🌵', category: 'Animals & Nature' },
  { emoji: '🌊', category: 'Animals & Nature' },
  { emoji: '🍄', category: 'Animals & Nature' },
  { emoji: '🌙', category: 'Travel & Places' },
  { emoji: '☀️', category: 'Travel & Places' },
  { emoji: '⭐', category: 'Travel & Places' },
  { emoji: '🌟', category: 'Travel & Places' },
  { emoji: '✨', category: 'Travel & Places' },
  { emoji: '💫', category: 'Travel & Places' },
  { emoji: '🌈', category: 'Travel & Places' },
  { emoji: '🔥', category: 'Travel & Places' },
  { emoji: '❄️', category: 'Travel & Places' },
  { emoji: '⛈️', category: 'Travel & Places' },
  { emoji: '🌊', category: 'Travel & Places' },
  { emoji: '🏔️', category: 'Travel & Places' },
  { emoji: '🌠', category: 'Travel & Places' },
  { emoji: '🪐', category: 'Travel & Places' },
  { emoji: '🌌', category: 'Travel & Places' },
  { emoji: '⚡', category: 'Travel & Places' },
  { emoji: '🌀', category: 'Travel & Places' },
  { emoji: '🎵', category: 'Objects' },
  { emoji: '🎨', category: 'Objects' },
  { emoji: '🎯', category: 'Objects' },
  { emoji: '🧩', category: 'Objects' },
  { emoji: '🔮', category: 'Objects' },
  { emoji: '💎', category: 'Objects' },
  { emoji: '🏆', category: 'Objects' },
  { emoji: '🎸', category: 'Objects' },
  { emoji: '🎹', category: 'Objects' },
  { emoji: '📚', category: 'Objects' },
  { emoji: '🎮', category: 'Objects' },
  { emoji: '🧸', category: 'Objects' },
  { emoji: '🪄', category: 'Objects' },
  { emoji: '🎭', category: 'Objects' },
  { emoji: '🎪', category: 'Objects' },
  { emoji: '🧲', category: 'Objects' },
  { emoji: '💡', category: 'Objects' },
  { emoji: '🔭', category: 'Objects' },
  { emoji: '🔬', category: 'Objects' },
  { emoji: '🧬', category: 'Objects' },
  { emoji: '❤️', category: 'Symbols' },
  { emoji: '💜', category: 'Symbols' },
  { emoji: '💙', category: 'Symbols' },
  { emoji: '💚', category: 'Symbols' },
  { emoji: '🧡', category: 'Symbols' },
  { emoji: '💛', category: 'Symbols' },
  { emoji: '🤍', category: 'Symbols' },
  { emoji: '🖤', category: 'Symbols' },
  { emoji: '🌈', category: 'Symbols' },
  { emoji: '⚜️', category: 'Symbols' },
  { emoji: '🔱', category: 'Symbols' },
  { emoji: '♻️', category: 'Symbols' },
  { emoji: '⚡', category: 'Symbols' },
  { emoji: '🌀', category: 'Symbols' },
  { emoji: '✳️', category: 'Symbols' },
  { emoji: '💠', category: 'Symbols' },
  { emoji: '🔷', category: 'Symbols' },
  { emoji: '🔹', category: 'Symbols' },
  { emoji: '🍎', category: 'Food & Drink' },
  { emoji: '🍊', category: 'Food & Drink' },
  { emoji: '🍋', category: 'Food & Drink' },
  { emoji: '🍇', category: 'Food & Drink' },
  { emoji: '🍓', category: 'Food & Drink' },
  { emoji: '🍒', category: 'Food & Drink' },
  { emoji: '🍑', category: 'Food & Drink' },
  { emoji: '🥝', category: 'Food & Drink' },
  { emoji: '🌮', category: 'Food & Drink' },
  { emoji: '🍕', category: 'Food & Drink' },
  { emoji: '🍜', category: 'Food & Drink' },
  { emoji: '🍣', category: 'Food & Drink' },
  { emoji: '🧁', category: 'Food & Drink' },
  { emoji: '🍰', category: 'Food & Drink' },
  { emoji: '🍦', category: 'Food & Drink' },
  { emoji: '🎃', category: 'Activities' },
  { emoji: '🎄', category: 'Activities' },
  { emoji: '🎆', category: 'Activities' },
  { emoji: '🎇', category: 'Activities' },
  { emoji: '🎑', category: 'Activities' },
  { emoji: '🧨', category: 'Activities' },
  { emoji: '🎗️', category: 'Activities' },
  { emoji: '🎟️', category: 'Activities' },
  { emoji: '🎠', category: 'Activities' },
  { emoji: '🎡', category: 'Activities' },
  { emoji: '🎢', category: 'Activities' },
  { emoji: '🎪', category: 'Activities' },
  { emoji: '🎭', category: 'Activities' },
  { emoji: '🎨', category: 'Activities' },
];

const BROADER_EMOJIS = BROADER_EMOJIS_RAW.filter(({ emoji, category }) => {
  if (BLOCKLIST_CATEGORIES.includes(category)) return false;
  if (BLOCKED_PATTERN.test(emoji)) return false;
  return true;
});

const BROADER_UNIQUE = Array.from(
  new Map(BROADER_EMOJIS.map(e => [e.emoji, e])).values()
);

interface CircleAvatarPickerProps {
  selected: string;
  onChange: (emoji: string) => void;
}

export default function CircleAvatarPicker({ selected, onChange }: CircleAvatarPickerProps) {
  const [showBroader, setShowBroader] = useState(false);

  return (
    <div>
      {selected && (
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 20 }}>
          <div style={{
            width: 80, height: 80, borderRadius: '50%',
            background: 'var(--color-bg-surface)',
            border: '3px solid var(--color-accent)',
            boxShadow: '0 0 32px var(--color-border)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 'var(--fs-4xl)',
          }}>
            {selected}
          </div>
        </div>
      )}

      <p style={{ fontSize: 'var(--fs-xs)', color: 'var(--color-text-secondary)', marginBottom: 12, textAlign: 'center' }}>
        Suggested — no faces, no flags
      </p>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(8, 1fr)', gap: 6, marginBottom: 16 }}>
        {CIRCLE_SUGGESTED_EMOJIS.map(emoji => (
          // eslint-disable-next-line cw/no-inline-button-style -- CircleAvatarPicker emoji swatch — square aspect-ratio:1 selected/unselected grid tile
          <button
            key={emoji}
            onClick={() => onChange(emoji)}
            aria-label={`Select ${emoji}`}
            aria-pressed={selected === emoji}
            style={{
              aspectRatio: '1',
              borderRadius: 'var(--radius-md)',
              border: selected === emoji ? '2px solid var(--color-accent)' : '1.5px solid color-mix(in srgb, var(--color-text-primary) 10%, transparent)',
              background: selected === emoji ? 'var(--color-bg-surface)' : 'color-mix(in srgb, var(--color-text-primary) 2%, transparent)',
              fontSize: 'var(--fs-lg-plus)',
              cursor: 'pointer',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              transition: 'all 0.15s',
              boxShadow: selected === emoji ? '0 0 0 2px var(--color-accent-light)' : 'none',
              padding: 0,
            }}
          >
            {emoji}
          </button>
        ))}
      </div>

      {/* eslint-disable-next-line cw/no-inline-button-style -- CircleAvatarPicker show-more toggle — full-width expand/collapse with ▲/▼ glyph */}
      <button
        onClick={() => setShowBroader(v => !v)}
        style={{
          width: '100%', padding: '10px 16px', borderRadius: 'var(--radius-md)',
          border: '1.5px solid color-mix(in srgb, var(--color-text-primary) 15%, transparent)',
          background: showBroader ? 'var(--color-accent-light)' : 'color-mix(in srgb, var(--color-text-primary) 2%, transparent)',
          color: showBroader ? 'var(--color-accent)' : 'var(--color-text-secondary)',
          fontSize: 'var(--fs-sm)', fontWeight: 600, cursor: 'pointer',
          display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
          marginBottom: showBroader ? 14 : 0,
        }}
      >
        {showBroader ? '▲ Hide more options' : '▼ Show more emoji options'}
      </button>

      {showBroader && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(8, 1fr)', gap: 6 }}>
          {BROADER_UNIQUE.map(({ emoji }) => (
            // eslint-disable-next-line cw/no-inline-button-style -- CircleAvatarPicker broader emoji swatch — square aspect-ratio:1 selected/unselected grid tile
            <button
              key={emoji}
              onClick={() => onChange(emoji)}
              aria-label={`Select ${emoji}`}
              aria-pressed={selected === emoji}
              style={{
                aspectRatio: '1',
                borderRadius: 'var(--radius-md)',
                border: selected === emoji ? '2px solid var(--color-accent)' : '1.5px solid color-mix(in srgb, var(--color-text-primary) 10%, transparent)',
                background: selected === emoji ? 'var(--color-bg-surface)' : 'color-mix(in srgb, var(--color-text-primary) 2%, transparent)',
                fontSize: 'var(--fs-lg-plus)',
                cursor: 'pointer',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                transition: 'all 0.15s',
                boxShadow: selected === emoji ? '0 0 0 2px var(--color-accent-light)' : 'none',
                padding: 0,
              }}
            >
              {emoji}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
